import React from 'react';
import { Button } from '../../../../Components/uielements';
import { ModalButtonWrapper } from '../../../../services/settings/appStyle/global.style';
import styled from 'styled-components';

const BlurredOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  background: #0b2629;
  border-radius: 16px;
  padding: 40px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid #e6b471;
`;

const SuccessMessage = styled.p`
  color: #ffffff;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 0 10px 0;
  text-align: center;
  font-weight: bold;
`;

const QRSection = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

const QRCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  border: 1px solid #e6b471;
  transition: all 0.3s ease;
  min-width: 200px;

  &:hover {
    transform: translateY(-4px);
    border-color: #e6b471;
  }
`;

const PlatformLabel = styled.div`
  color: #e6b471;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const QRPlaceholder = styled.div`
  width: 160px;
  height: 160px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  border: 2px solid #e6b471;
`;

const QRImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
`;

const ScanText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin: 0;
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(230, 180, 113, 0.3), transparent);
  margin: 24px 0;
`;

const InfoText = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  text-align: center;
  line-height: 1.5;
`;

const StyledButtonWrapper = styled(ModalButtonWrapper)`
  margin-top: 0;
  display: flex;
  justify-content: center;
`;

const FreeUserPopUpMessage = ({ onClose, androidQR, iosQR }) => {
  return (
    <BlurredOverlay>
      <ContentWrapper>
        <SuccessMessage>Mobile App Access Only</SuccessMessage>
        <InfoText>
          Access to the Web Admin Panel is restricted for your role. Please scan the code below to
          access your account via the mobile app.
        </InfoText>{' '}
        <Divider />
        <QRSection>
          <QRCard>
            <PlatformLabel>Android</PlatformLabel>
            <QRPlaceholder>
              {androidQR ? (
                <QRImage src={androidQR} alt="Android QR Code" />
              ) : (
                <div style={{ color: '#161a3b', fontSize: '12px', padding: '20px' }}>
                  Android QR Code
                </div>
              )}
            </QRPlaceholder>
            <ScanText>Scan with your Android device</ScanText>
          </QRCard>

          <QRCard>
            <PlatformLabel>iOS</PlatformLabel>
            <QRPlaceholder>
              {iosQR ? (
                <QRImage src={iosQR} alt="iOS QR Code" />
              ) : (
                <div style={{ color: '#161a3b', fontSize: '12px', padding: '20px' }}>
                  iOS QR Code
                </div>
              )}
            </QRPlaceholder>
            <ScanText>Scan with your iPhone or iPad</ScanText>
          </QRCard>
        </QRSection>
        <StyledButtonWrapper>
          <Button
            varient="normal"
            onClick={onClose}
            style={{
              backgroundColor: '#e6b471',
              color: '#0b2629',
            }}
          >
            Close
          </Button>
        </StyledButtonWrapper>
      </ContentWrapper>
    </BlurredOverlay>
  );
};

export default FreeUserPopUpMessage;
